import { render, staticRenderFns } from "./SlideFormAssignTrip.vue?vue&type=template&id=6b2887aa&scoped=true"
import script from "./SlideFormAssignTrip.vue?vue&type=script&lang=js"
export * from "./SlideFormAssignTrip.vue?vue&type=script&lang=js"
import style0 from "./SlideFormAssignTrip.vue?vue&type=style&index=0&id=6b2887aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2887aa",
  null
  
)

export default component.exports